<template>
  <div>
    <div class="live-top-title">
      <div class="title-in">
        <span>直播名称:</span>
        <span>{{ liveInfo.Title || "- -" }}</span>
      </div>
      <div class="title-in">
        <span>教师名称 :</span>
        <span>{{ liveInfo.TeacherName || "- -" }}</span>
      </div>
    </div>
    <div class="live-container">
      <div class="live-not-start" v-if="liveInfo.LiveStatus === 0">
        <div class="live-title">{{ liveInfo.Title }}</div>
        <div class="live-icon">
          <img src="../../assets/images/v3/live-not-start.png" />
        </div>
        <div class="live-text">
          <p>将在{{ liveInfo.StartDate }}开播</p>
          <p>可提前5分钟进入直播间</p>
        </div>
      </div>
      <div id="loading" v-show="started"></div>
      <live-index
        v-if="loaded && started"
        :info="liveInfo"
        :playback="playbackData"
      ></live-index>
    </div>
    <!-- <div class="bg-white-wrapper">
      <ul class="live-detail-tabs-nav">
        <li class="active">直播介绍</li>
        <li ref="tabNavLine" class="highlight"></li>
      </ul>
      <div class="container live-details" v-html="liveInfo.Introduce"></div>
    </div> -->

    <Modal
      v-model="nickNameModalVisible"
      width="360"
      :closable="false"
      :mask-closable="false"
    >
      <p slot="header" style="color: #f60; text-align: center">
        <Icon type="ios-information-circle"></Icon>
        <span>请输入昵称</span>
      </p>
      <div style="text-align: center">
        <Input
          v-model="liveNickName"
          placeholder="请输入昵称"
          style="width: 320px"
        />
      </div>
      <div slot="footer">
        <Button type="error" size="large" long @click="setNickNameFunc"
          >确定</Button
        >
      </div>
    </Modal>
  </div>
</template>
<script>
import { siteMixin } from "../../utils/mixin";
import { getToken } from "../../utils/localStorage";
import LiveIndex from "../../components/live/Index.vue";
import { study, account } from "../../request";
const eventEmitter = BJY.eventEmitter;
export default {
  mixins: [siteMixin],
  components: {
    LiveIndex,
  },
  data() {
    return {
      loaded: false,
      started: false,
      liveId: 0,
      liveInfo: {},
      nickNameModalVisible: false,
      liveNickName: "",
      liveParams: {},
      playbackParams: {},
      playbackData: {},
    };
  },
  created() {
    this.setMetaData("直播");
    this.liveId = this.$route.params.id;
  },
  mounted() {
    if (!this.liveId) return;
    this.handleLoginAndJump();
    // this.loadLiveRoom();
    // this.started = true;
  },
  methods: {
    async handleLoginAndJump() {
      // 自营平台，强制跳转到HTTPS。如有登录，则自动登录
      const protocol = window.location.protocol;
      const domain = window.location.hostname;
      const path = window.location.pathname;
      let token = "";
      const authToken = getToken();
      if (authToken && authToken.nextAuth) {
        token = authToken.nextAuth;
      }
      // 跳转到https
      if (
        protocol == "http:" &&
        domain.indexOf("beegoedu.com") < 0 &&
        this.siteConfig.agencyId > 0 &&
        process.env.NODE_ENV !== "development"
      ) {
        window.location.href = `https://${process.env.VUE_APP_WEB_DOMAIN}${path}?agencyId=${this.siteConfig.agencyId}&token=${token}`;
        return;
      }

      //获取直播登录类型，未登录时，根据登录类型，转到不同登录页面
      await this.getLiveType();
      let liveLogin = true;
      if (this.loginType == 3) {
        liveLogin = false;
      }
      //非自营机构，根据直播类型进行强制登录
      if (this.siteConfig.agencyId != 0 && !this.isLogin && liveLogin) {
        this.$router.push({
          name: "LoginLive",
          query: { redirect: this.$route.fullPath },
        });
        return;
      }
      //通过后，初始化并获取直播数据
      this.initLiveData();
    },
    async getLiveType() {
      const liveId = this.$route.params.id;
      if (!liveId) return;
      const result = await account.getLiveLoginType(liveId);
      if (result.status === 1) {
        this.loginType = result.data;
      }
      return result;
    },
    initLiveData() {
      // 处理ID和昵称
      this.noLoginUserId = `${Math.round((Math.random() + 1) * 10000)}`; // 未登录时随机用户Id
      let userName = "";
      let userId = "";
      // 已登录，取登录信息
      if (this.isLogin) {
        userId = this.loginUser.userId;
        userName = this.loginUser.nickName;
        if (!userName) {
          userName = this.loginUser.userName;
        }
      }
      // 拼接用户ID。如果是手机号，晕行*号替换。
      // if (userName) {
      //   const reg = new RegExp('\\d{7}(\\d{4})');
      //   userName = userName.replace(reg, '*******$1');
      //   userId && (userName += `(${userId})`);
      // }
      if (!userName) {
        // 无名称，弹开昵称设置窗口设置昵称
        this.nickNameModalVisible = true;
      } else {
        // 有，请求直播数据
        this.liveNickName = userName;
        this.getLiveData();
      }
    },
    setNickNameFunc() {
      if (!!this.liveNickName) {
        this.nickNameModalVisible = false;
        this.getLiveData();
      } else {
        this.$Message.error("请输入昵称");
      }
    },
    getUserAvatar() {
      const defaultBoy = `https://${process.env.VUE_APP_WEB_DOMAIN}/img/avatar-boy.png`;
      //const defaultGirl = `https://${process.env.VUE_APP_WEB_DOMAIN}/img/avatar-girl.png`;
      if (!this.isLogin || !this.loginUser.pic) return defaultBoy;
      return this.concatImageUrl(this.loginUser.pic, 100, 100, true);
    },
    getLiveData() {
      const valid = this.$route.query.v && 1;
      study
        .getLiveInfo(
          this.liveId,
          this.isLogin ? this.loginUser.userId : 0,
          this.liveNickName,
          valid,
        )
        .then((res) => {
          if (res.status === 1) {
            //昵称隐藏处理
            this.liveNickName = this.liveNickName.replace(
              /(^.).+(.$)/,
              "$1***$2",
            );
            this.liveInfo = res.data;
            console.log("直播数据", this.liveInfo);
            // 直播未开始
            if (this.liveInfo.LiveStatus === 0) {
              return;
            }
            this.started = true;
            // 正在直播
            if (this.liveInfo.LiveStatus === 1) {
              this.getLiveSign();
            } else if (
              // 观看回放
              this.liveInfo.IsBackLive == 1 &&
              this.liveInfo.LiveStatus === 2 &&
              this.liveInfo.playbackStatus === 4
            ) {
              this.getPlaybackToken();
            } else {
              this.$router.push({
                name: "LiveEnd",
              });
            }
          } else {
            this.$Message.error("直播请求异常");
          }
        })
        .catch(() => {
          this.$Message.error("直播请求异常");
        });
    },
    // 直播签名
    getLiveSign() {
      study
        .getLiveSign({
          liveId: this.liveId,
          userId: this.isLogin ? this.loginUser.userId : this.noLoginUserId,
          userName: this.liveNickName,
          userAvatar: this.getUserAvatar(),
          agencyId: this.siteConfig.agencyId,
        })
        .then((res) => {
          if (res.status === 1) {
            this.liveParams = res.data;
            this.loadLiveRoom();
          } else {
            this.$Message.error("直播请求异常");
          }
        });
    },
    // 回放TOKEN
    getPlaybackToken() {
      study
        .getPlaybackToken({
          liveId: this.liveId,
          agencyId: this.siteConfig.agencyId,
        })
        .then((res) => {
          if (res.status === 1) {
            this.playbackParams = res.data;
            this.loadPlayback();
          }
        });
    },
    loadLiveRoom() {
      const loading = BJY.Loading.create({
        element: $("#loading"),
        // logoUrl: `https://${process.env.VUE_APP_WEB_DOMAIN}/img/logo.png`,
      });
      eventEmitter.one(eventEmitter.LOADING_PANEL_END, (event, data) => {
        //加载完成时事件
        loading.destroy();
        this.loaded = true;
      });

      eventEmitter.one(
        eventEmitter.CLASSROOM_CONNECT_TRIGGER,
        (event, data) => {
          // 初始化扩展
          var extension = BJY.getExtension();
          if (BJY.browser.wechat) {
            extension = BJY.Player.html;
          }
          // PC 不支持 m3u8，这里强制使用 flv
          if (extension === BJY.Player.html) {
            extension.extensions.useFlv = true;
          }
          // 如果您使用的是webrtc拓展的话，请确保引入了realtimecat.js这个依赖，否则此处会报undefined：RTCat
          extension.init().then(() => {
            eventEmitter.trigger(eventEmitter.CLASSROOM_CONNECT_TRIGGER, data);
          });
          return false;
        },
      );

      this.initLiveRoom();
    },
    initLiveRoom() {
      const options = {
        // prefixName: '',
        env: "production",
        room_id: this.liveParams.roomId,
        user_number: this.liveParams.userId,
        user_avatar: this.getUserAvatar(),
        user_name: this.liveNickName,
        user_role: this.liveParams.userRole,
        group_id: this.liveParams.groupId,
        sign: this.liveParams.sign,
        webrtc: 1,
      };
      BJY.init({
        env: options.env,
        // privateDomainPrefix: options.prefixName,
        class: {
          id: options.room_id,
        },
        user: {
          number: options.user_number,
          // avatar: decodeURIComponent(options.user_avatar),
          // name: decodeURIComponent(options.user_name),
          avatar: options.user_avatar,
          name: options.user_name,
          type: Number(options.user_role),
          group: options.group_id,
        },
        sign: options.sign,
        needCheckUnique: true,
      });
    },
    loadPlayback() {
      const loading = BJY.playback.Loading.create({
        element: $("#loading"),
        onComplete: () => {
          this.loaded = true;
          loading.destroy();
        },
      });
      this.initPlayback();
    },
    initPlayback() {
      const options = {
        token: this.playbackParams.token,
        classId: this.playbackParams.roomId,
        sessionId: 0,
        groupId: this.playbackParams.groupId,
      };
      BJY.playback
        .init({
          env: "production",
          token: options.token,
          class: {
            id: options.classId,
            sessionId: options.sessionId,
          },
          useEncrypt: true,
          user: {
            number: this.isLogin ? this.loginUser.userId : this.noLoginUserId,
            avatar: this.getUserAvatar(),
            name: this.liveNickName,
            type: 0,
            group: options.groupId,
          },
        })
        .then((data) => {
          console.log("playbackData", data);
          this.playbackData = data; // 播放信息
        });
    },
  },
};
</script>
<style lang="less" scoped>
@import "../../assets/css/var.less";
.live-top-title {
  /* margin-top: 22px; */
  padding-left: 30px;
  display: flex;
  align-items: center;
  width: 100%;
  height: 48px;
  /* border-radius: 20px 20px 0 0; */
  background: #222222;
  .title-in {
    color: #fff;
    margin-right: 50px;
  }
}
.live-container {
  position: relative;
  background-color: #2f3133;
  /* padding: 20px 20px; */
  height: calc(100vh - 48px);
  overflow: hidden;
}
.live-not-start {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 1200px;
  height: 600px;
  margin: 0 auto;
  background: #0ba0dd;
  z-index: 200;

  .live-title {
    color: #fff;
    font-size: 22px;
  }
  .live-icon {
    margin: 40px 0 80px 0;
  }
  .live-text {
    color: #fff;
    text-align: center;
    line-height: 1.6;
    font-size: 16px;
  }
}
.live-detail-tabs-nav {
  width: 1200px;
  margin: 0 auto;
  position: relative;
  background: #fff;
  height: 55px;
  border-bottom: 2px solid #0195d3;
  li {
    position: relative;
    float: left;
    width: 150px;
    padding: 15px 25px;
    text-align: center;
    cursor: pointer;
    z-index: 1;
    transition: all 0.2s ease;
    &:hover,
    &.active {
      color: #ff7d2b;
    }
    &.highlight {
      position: absolute;
      left: 0;
      top: 0;
      width: 150px;
      height: 57px;
      border-bottom: 6px solid #ff7d2b;
      background-color: #fff;
      z-index: 0;
      transition: all 0.2s ease;
    }
  }
}
.live-details {
  padding: 20px 0;
  min-height: 300px;
}
</style>
